<template>
  <div class="auto-equipment">
    <h3 class="auto-equipment__title">
      {{ title }}
    </h3>

    <div class=" d-flex">
      <div class="auto-equipment__list-wrapper">
        <h4 class="auto-equipment__list-title">
          {{ $t('mechanic.autoLastState') }}
        </h4>

        <ul class="auto-equipment__list">
          <li
            v-for="(name, key) in params"
            :key="key"
            class="auto-equipment__list-item"
          >
            <v-select
              v-if="isCountSelect(key)"
              color="warning"
              item-value="value"
              item-text="text"
              :label="name"
              :items="countOptions"
              :value="prevState[key]"
              readonly
            />
            <v-select
              v-else
              color="warning"
              item-value="id"
              item-text="title"
              :label="name"
              :items="options || defaultOptions"
              :value="prevState[key]"
              readonly
            />

            <v-tooltip
              v-if="commentParam && prevStateComments[key]"
              color="warning"
              content-class="comment-tooltip"
              max-width="300"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs" class="ml-2">
                  <v-icon color="warning">
                    mdi-comment-text
                  </v-icon>
                </div>
              </template>

              {{ prevStateComments[key] }}
            </v-tooltip>
          </li>
        </ul>
      </div>

      <div class="auto-equipment__list-wrapper">
        <h4 class="auto-equipment__list-title">
          {{ $t('navigation.currentState') }}
        </h4>

        <ul class="auto-equipment__list">
          <li
            v-for="(name, key) in params"
            :key="key"
            class="auto-equipment__list-item"
          >
            <v-select
              v-if="isCountSelect(key)"
              color="warning"
              item-value="value"
              item-text="text"
              :label="name"
              :items="countOptions"
              :value="formData[key]"
              clearable
              @change="
                $emit('update:form-data', { ...formData, [key]: $event })
              "
            />
            <v-select
              v-else
              color="warning"
              item-value="id"
              item-text="title"
              :label="name"
              :items="options || defaultOptions"
              :value="formData[key]"
              clearable
              @change="onSelectChange({ key, value: $event })"
            />

            <v-tooltip
              v-if="commentParam && formData[key] === commentParam"
              :color="comments[key] ? 'warning' : ''"
              top
            >
              <template #activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  class="ml-2"
                  color="warning"
                  icon
                  @click="
                    () => {
                      commentDialog.opened = true;
                      commentDialog.param = key;
                      commentDialog.value = comments[key];
                    }
                  "
                >
                  <v-icon>
                    mdi-comment-text
                  </v-icon>
                </v-btn>
              </template>

              <span v-if="comments[key]">
                {{ comments[key] }}
              </span>

              <i v-else>{{ $t('common.fields.commentAdd') }}</i>
            </v-tooltip>
          </li>
        </ul>
      </div>
    </div>

    <text-field-edit-dialog
      v-model="commentDialog.opened"
      :param-name="commentDialog.param"
      :currentValue="commentDialog.value"
      :label="$t('common.fields.comment')"
      @save="$emit('update:comments', { ...comments, ...$event })"
    />
  </div>
</template>

<script>
import TextFieldEditDialog from '@/components/shared/TextFieldEditDialog.vue';

export default {
  components: { TextFieldEditDialog },
  props: {
    options: {
      type: [Array, null],
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    prevState: {
      type: Object,
      default: () => ({}),
    },
    prevStateComments: {
      type: Object,
      default: () => ({}),
    },
    countList: {
      type: Array,
      default: () => [],
    },
    comments: {
      type: Object,
      default: () => ({}),
    },
    commentParam: {
      type: [String, null],
      default: null,
    },
  },
  data: () => ({
    commentDialog: {
      opened: false,
      param: '',
      value: '',
    },
  }),
  computed: {
    defaultOptions() {
      return [
        {
          id: '0',
          title: this.$t('common.fields.noItem'),
        },
        {
          id: '1',
          title: this.$t('common.fields.yesItem'),
        },
      ];
    },
    countOptions() {
      return [
        { text: this.$t('common.fields.noItem'), value: '0' },
        { text: 1, value: '1' },
        { text: 2, value: '2' },
        { text: 3, value: '3' },
        { text: 4, value: '4' },
        { text: 5, value: '5' },
      ];
    },
  },
  methods: {
    isCountSelect(key) {
      return this.countList.includes(key);
    },
    onSelectChange({ key, value }) {
      this.$emit('update:form-data', { ...this.formData, [key]: value });

      if (this.commentParam) {
        const comments = { ...this.comments };
        delete comments[key];
        this.$emit('update:comments', comments);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.auto-equipment {
  margin-top: 50px;

  &__title {
    font-size: 18px;
    font-weight: 500;
    color: #464646;
    margin-bottom: 30px;
  }

  &__list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0;
    padding: 15px;

    &-wrapper {
      width: 50%;

      &:first-child {
        border-right: 1px dashed #a4a4a4;
        padding-right: 30px;
      }

      &:last-child {
        padding-left: 30px;
      }
    }

    &-title {
      margin-bottom: 10px;
      font-weight: 500;
      color: #464646;
      text-align: center;
    }

    &-item {
      display: flex;
      align-items: center;
      list-style: none;
      padding: 0;
      margin: 0;
      width: 45%;

      .v-select,
      ::v-deep .v-label {
        font-size: 15px !important;
      }
    }
  }
}
</style>
